import { PlusIcon, TrashIcon } from '@heroicons/react/24/outline';
//@ts-ignore: Missing types in `beautiful-react-hooks`
import useDebouncedCallback from 'beautiful-react-hooks/useDebouncedCallback';
import { useEffect, useState } from 'react';

import { Button } from '@/components/core/Button';
import { Icon } from '@/components/core/Icon';
import { Input } from '@/components/core/Input';
import { useTranslation } from '@/hooks/useTranslation';
import { useUser } from '@/hooks/useUser';

interface MainPageToolbarProps {
    textFilter?: string;
    onTextFilterChange: (newValue: string) => void;
    onNewContentClick: () => void;
    deleteEnabled: boolean;
    onDeleteClick: () => void;
}

const MainPageToolbar = ({
    textFilter,
    onTextFilterChange,
    onNewContentClick,
    deleteEnabled,
    onDeleteClick,
}: MainPageToolbarProps ) => {

    const { t } = useTranslation();
    const { user } = useUser();
    const [ internalTextFilter, setInternalTextFilter ] = useState<string | undefined>(textFilter);
    const debouncedOnTextFilterChange = useDebouncedCallback(onTextFilterChange);

    useEffect(() => {
        debouncedOnTextFilterChange(internalTextFilter);
    }, [internalTextFilter, debouncedOnTextFilterChange]);

    useEffect(() => {
        setInternalTextFilter(textFilter);
    }, [textFilter]);

    return (
        !user?.roles?.contains('bulk_subscription_viewer') && (<div className="tw-flex tw-flex-col tw-w-full tw-mb-2">
            <Input
                className="tw-flex-none tw-w-full tw-mb-2"
                placeholder={t('BULK_SUBSCRIPTION.SEARCH')}
                title={t('BULK_SUBSCRIPTION.SEARCH')}
                value={internalTextFilter}
                onChange={(event) => setInternalTextFilter(event.target.value)}
            />
            <div className="tw-flex tw-w-full tw-gap-3">
                <Button
                    variant="default"
                    onClick={onNewContentClick}
                    title={t('BULK_SUBSCRIPTION.NEW_SUBSCRIPTION')}
                >
                    <span className="tw-flex tw-flex-none tw-justify-center tw-items-center">
                        <Icon icon={PlusIcon} size="sm" variant="light" className='tw-mt-[-2px] tw-stroke-2' />
                        <span className="tw-ml-2 tw-truncate">{t('BULK_SUBSCRIPTION.NEW_SUBSCRIPTION')}</span>
                    </span>
                </Button>
                <Button
                    variant="destructive"
                    onClick={onDeleteClick}
                    title={t('ACTION.DELETE')}
                    disabled={!deleteEnabled}
                >
                    <span className="tw-flex tw-flex-none tw-justify-center tw-items-center">
                        <Icon icon={TrashIcon} size="sm" variant="destructive" disabled={!deleteEnabled} className='tw-mt-[-3px]' />
                        <span className="tw-ml-2 tw-truncate">{t('ACTION.DELETE')}</span>
                    </span>
                </Button>
            </div>
        </div>)
    );
};

export { MainPageToolbar };
